@if (invoice(); as i) {
<div class="detail-section">
  <table class="detail-table">
    <tbody>
      <tr>
        <td>
          <strong>Invoice Number</strong>
          <p>{{ i.refNumber || '-' }}</p>
        </td>
        <td>
          <strong>Date</strong>
          <p>{{ i.date ? (i.date | date: 'mediumDate') : '-' }}</p>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div class="detail-section">
  <table class="detail-table">
    <tbody>
      <tr>
        <td>
          <strong>Billing Account</strong>
          <p>{{ i.acctName || '-' }}</p>
        </td>
        <td>
          <strong>Type</strong>
          <p>
            <span class="status-badge">{{ billingTypeLabel() }}</span>
          </p>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div class="detail-section">
  <table class="detail-table">
    <tbody>
      <tr>
        <td>
          <strong>Total Amount</strong>
          <p>{{ i.totalAmount != null ? (i.totalAmount | currency: 'USD') : '-' }}</p>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div class="detail-section">
  <h3 class="detail-section__heading">Actions</h3>
  <div class="detail-actions">
    @if (canDownloadPdf()) {
      <button type="button" class="detail-action-btn" (click)="downloadInvoice()">
        Download Invoice
      </button>
    } @else {
      <p class="detail-empty">Invoice PDF Unavailable</p>
    }
    <button type="button" class="detail-action-btn detail-action-btn--secondary" (click)="downloadDetails()">
      Download Details
    </button>
  </div>
</div>
}
